import { useTranslation } from 'react-i18next';
import { DoughnutChart } from 'src/common/components/Graphs/common/Graphs/DoughnutChart';
import { RGU_FILTER } from 'src/dashboard/Charts/api/DashboardApi';
import { useSubscriptionStatusData } from 'src/dashboard/Charts/hooks/useSubscriptionStatusData';

export const RSimSubscriptionStatusChart = ({ accountRef }: { accountRef: string }) => {
  const { t } = useTranslation();

  const { chartData, total } = useSubscriptionStatusData({
    rguFilter: RGU_FILTER.RSIM,
    accountRef,
  });

  return (
    <DoughnutChart
      data={chartData}
      total={total}
      aria-label={t('dashboard.subscriptionsStatusChart.title')}
    />
  );
};
